import React, { useCallback } from "react"
import { useNavigate, useLocation, Outlet } from "react-router-dom"
import DSTab from "ui/DSTab"
import { useTranslation } from "react-i18next"
import { routes } from "router/routes"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import tabStyles from "./index.module.css"

const ResourcesContainer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { hasPermission } = usePermissions()

  // Determine active tab from URL
  const activeTab = location.pathname.includes("/resources/crew") ? "crew" : "equipment"

  const handleTabChange = useCallback((tab) => {
    if (tab === "equipment") {
      navigate(routes.guideResourcesEquipmentPath())
    } else if (tab === "crew") {
      navigate(routes.guideResourcesCrewPath())
    }
  }, [navigate])

  const tabItems = [
    {
      key: "equipment",
      label: t("resources.equipment")
    },
    hasPermission(MODULES.CREW, ACTIONS.VIEW) && {
      key: "crew",
      label: t("resources.crew")
    }
  ].filter(Boolean)

  return (
    <>
      <DSTab
        items={tabItems}
        activeKey={activeTab}
        onChange={handleTabChange}
        className={tabStyles.tabs}
      />
      <Outlet />
    </>
  )
}

export default React.memo(ResourcesContainer)
